import { store } from './store/store';
import { updateAppState } from './store/appReducer';
import { setRouteName } from './store/routerReducer';

export const ROUTE_DATE_PICKER = 'ROUTE_DATE_PICKER';
export const ROUTE_RESULT = 'ROUTE_RESULT';
export const ROUTE_ARKANE_DECODE = 'ROUTE_ARKANE_DECODE';

/*
window.onpopstate = function(event) {
	//console.log('onpopstate', window.location, event);
};
*/

// TODO: Move To App Level? Or else?

store.dispatch(updateAppState({
    locationHash: window.location.hash || '',
    locationSearch: window.location.search || '',
}));

/*
if ("onhashchange" in window) {
    window.onhashchange = function(event) {
        console.log('onhashchange', window.location, event);
        if ( !event || !event.newURL ) {
            return;
        }
        
        let hashPart = String(event.newURL).split('#');
        if ( !hashPart.length || (hashPart.length < 2) ) {
            return;
        }

        store.dispatch(changePanelByHash(hashPart[hashPart.length-1]));
    }
}
*/

// TODO: Tmp. Надо, видимо, потом все-таки сделать роутер нормальный...
store.dispatch(setRouteName(ROUTE_DATE_PICKER));